const translations = {
  en: {
    companyName: "zeiia",
    nav: { services: "Services", whyUs: "Why Us", process: "Process", contact: "Get Started" },
    hero: {
      badge: "Your tech partner",
      title: "We Build ", titleAccent: "Smart", titleEnd: " Digital Solutions.",
      sub: "We partner with ambitious startups and established businesses to engineer scalable software that drives growth and simplifies complexity.",
      cta1: "Free Consultation", cta2: "Our Services",
    },
    services: {
      tag: "Core Expertise",
      title: "End-to-end development services tailored to your needs",
      items: [
        { title: "Web Development",   desc: "Custom enterprise-grade web applications built with modern frameworks." },
        { title: "Mobile Apps",       desc: "Native and cross-platform mobile solutions for iOS and Android." },
        { title: "UI/UX Design",      desc: "User-centric design focused on conversion and intuitive navigation." },
        { title: "System Integration",desc: "Connecting your software systems to eliminate data silos." },
      ],
    },
    whyUs: {
      tag: "The Advantage",
      title: "Why forward-thinking brands choose zeiia",
      items: [
        { title: "Fast Delivery",       desc: "Agile methodologies that ensure quick turnarounds." },
        { title: "Scalable Solutions",  desc: "Architecture designed to grow with your business." },
        { title: "Business-Oriented",   desc: "We solve business problems to drive your ROI." },
        { title: "Dedicated Support",   desc: "Ongoing maintenance to keep you running smoothly." },
      ],
    },
    process: {
      tag: "Our Workflow", title: "Simple. Transparent. Effective.",
      steps: [
        { title: "Understand", desc: "Deep analysis of your requirements and goals." },
        { title: "Design",     desc: "Crafting the visual identity and user journey." },
        { title: "Develop",    desc: "High-quality coding with continuous feedback." },
        { title: "Launch",     desc: "Deployment and ongoing optimization." },
      ],
    },
    about: {
      tag: "About Us",
      title: "A vision for digital excellence.",
      desc: "Founded by engineers and product thinkers, zeiia bridges the gap between complex technology and meaningful human experience. We empower startups with world-class technology.",
    },
    contact: {
      tag: "Contact", title: "Let's talk about your project.",
      sub: "Fill out the form, or reach out directly. We respond within 12 hours.",
      formName: "Full Name", formEmail: "Email Address",
      formMsg: "How can we help?", formBtn: "Send Message",
      success: "Message Sent!", successSub: "Our team will get back to you shortly.",
    },
    footer: {
      desc: "Engineering digital foundations for the world's next great companies.",
      rights: "© 2026 zeiia. All rights reserved.",
    },
  },
  ar: {
    companyName: "زيا",
    nav: { services: "خدماتنا", whyUs: "لماذا زيا", process: "كيف نعمل", contact: "ابدأ مشروعك" },
    hero: {
      badge: "شريكك التقني من الفكرة حتى الإطلاق",
      title: "نبني حلولاً رقمية ", titleAccent: "تدوم", titleEnd: " وتنمو.",
      sub: "نصمم ونطور برمجيات مخصصة تساعد الشركات الناشئة والمؤسسات الراسخة على التوسع، وتحويل العمليات المعقدة إلى تجارب رقمية سلسة.",
      cta1: "احجز استشارة مجانية", cta2: "تعرف على خدماتنا",
    },
    services: {
      tag: "ما نقدمه",
      title: "خدمات تطوير برمجي متكاملة، من الفكرة إلى المنتج",
      items: [
        { title: "تطوير المواقع والمنصات", desc: "نبني مواقع ومنصات ويب احترافية قابلة للتوسع، مُحسَّنة للأداء ومتوافق ة مع معايير SEO." },
        { title: "تطبيقات الجوال",         desc: "تطبيقات iOS وAndroid أصيلة وعابرة للمنصات، مُصممة لتجربة مستخدم سلسة وأداء عالٍ." },
        { title: "تصميم تجربة المستخدم",   desc: "واجهات مدروسة تجمع بين الجماليات والوظيفة، لتحقيق أعلى معدلات التفاعل والتحويل." },
        { title: "تكامل الأنظمة والـ API", desc: "نربط أنظمتك ببعضها لإلغاء الازدواجية وتدفق البيانات بدقة بين جميع أدواتك." },
      ],
    },
    whyUs: {
      tag: "لماذا زيا",
      title: "نبني علاقات طويلة الأمد، لا مجرد مشاريع",
      items: [
        { title: "تسليم في الوقت المحدد",          desc: "نعمل بمنهجية Agile مع جداول زمنية واضحة وتحديثات أسبوعية طوال مدة المشروع." },
        { title: "بنية تحتية قابلة للتوسع",         desc: "نصمم الكود ليتحمل النمو، سواء كان لديك مئة مستخدم أو مليون." },
        { title: "شريك في النمو لا مجرد مُنفِّذ",   desc: "نفهم أهدافك التجارية ونقيس نجاحنا بعائدك الفعلي، لا بعدد السطور البرمجية." },
        { title: "دعم ما بعد الإطلاق",              desc: "لا ننتهي عند التسليم، نبقى معك للصيانة والتطوير المستمر بعد الإطلاق." },
      ],
    },
    process: {
      tag: "كيف نعمل", title: "منهجية واضحة في أربع خطوات.",
      steps: [
        { title: "الاستيعاب",      desc: "نغوص في تفاصيل مشروعك، سوقك، وأهدافك قبل أي سطر كود." },
        { title: "التصميم",        desc: "نرسم تجربة المستخدم والهوية البصرية مع مراجعتك في كل مرحلة." },
        { title: "التطوير",        desc: "نكتب كوداً نظيفاً وقابلاً للتطوير مع اختبار مستمر وتحديثات أسبوعية." },
        { title: "الإطلاق والنمو", desc: "ننشر المنتج ونرافقك في مرحلة النمو بتحديثات وتحسينات دورية." },
      ],
    },
    about: {
      tag: "من نحن",
      title: "فريق هندسي يفهم الأعمال قبل التقنية.",
      desc: "زيا شركة برمجيات متخصصة في بناء منتجات رقمية للشركات الناشئة والمؤسسات. نؤمن بأن التقنية الجيدة يجب أن تخدم هدفاً تجارياً واضحاً، لذلك نبدأ دائماً بفهم عملك قبل كتابة أي كود.",
    },
    contact: {
      tag: "تواصل معنا", title: "أخبرنا عن مشروعك.",
      sub: "أرسل لنا تفاصيل مشروعك وسيتواصل معك أحد مستشارينا خلال 12 ساعة عمل.",
      formName: "الاسم الكامل", formEmail: "البريد الإلكتروني",
      formMsg: "صف لنا مشروعك باختصار", formBtn: "أرسل طلبك",
      success: "وصلنا طلبك!", successSub: "سيتواصل معك أحد مستشارينا قريباً.",
    },
    footer: {
      desc: "نبني الأساس التقني للشركات التي تريد أن تدوم.",
      rights: "© 2026 زيا. جميع الحقوق محفوظة.",
    },
  },
};

export default translations;
